module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/icon_try_on_dress-71eef0a21beb813ccbf6806087814753.png";